import { render } from "./projectView.vue?vue&type=template&id=fde4ea24&scoped=true"
import script from "./projectView.vue?vue&type=script&lang=js"
export * from "./projectView.vue?vue&type=script&lang=js"

import "./projectView.vue?vue&type=style&index=0&id=fde4ea24&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde4ea24"]])

export default __exports__